var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseMap',{attrs:{"geojson":JSON.parse(_vm.data.geojson),"geostyle":_vm.data.geostyle,"height":_vm.data.height,"width":_vm.data.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }